export default __webpack_public_path__ + "static/media/dns.ae892195.svg";